import React, { type FC } from 'react'

interface IconCircleExclamationProps {
  width?: string
  height?: string
  fill?: string
}

const IconCircleExclamation: FC<IconCircleExclamationProps> = (
  { width, height, fill } = { fill: 'currentColor' },
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        shapeRendering="geometricPrecision"
        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
      />
    </svg>
  )
}

export default IconCircleExclamation
